import React from 'react';
import * as PropTypes from 'prop-types';
import useMedia from 'use-media';
import Breadcrumb from '@/yema-designkit/webkit/atoms/Breadcrumb';

const YDSProductPageBreadcrumb = ({ productBreadcrumb }) => {
    const isMobile = useMedia({ maxWidth: 1024 });
    const beforeLastLink =
        productBreadcrumb.length >= 2 ? productBreadcrumb[productBreadcrumb.length - 2] : null;

    const lastProductBreadcrumbItem = [
        {
            title: <a href={beforeLastLink.link}>{`< Regresar a ${beforeLastLink.title}`}</a>,
        },
    ];

    if (!productBreadcrumb || !productBreadcrumb.length) return '';

    return (
        <div className='container'>
            <div className='block'>
                <div className='row'>
                    <div className='col'>
                        <Breadcrumb
                            className='my-4 lg:my-6'
                            breadcrumbs={
                                beforeLastLink && isMobile
                                    ? lastProductBreadcrumbItem
                                    : productBreadcrumb
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

YDSProductPageBreadcrumb.defaultProps = {};

YDSProductPageBreadcrumb.propTypes = {
    productBreadcrumb: PropTypes.array.isRequired,
};

export default YDSProductPageBreadcrumb;
